import * as React from "react";
import styled from "styled-components";

import { Text } from "../../../../components/atoms";
import {
  AccountView,
  TextDoubleHeader,
} from "../../../../components/molecules";
import { ILoginUser } from "../../../../services/api/customer";

interface IProps {
  creditBalance: number;
  isLoggedIn: boolean;
  usersFields: ILoginUser;
}

const AccountInfoWrapper = styled.div`
  margin-top: 16px;
`;

const AccountInfo: React.FC<IProps> = (props) => {
  return (
    <AccountInfoWrapper>
      <TextDoubleHeader>
        <Text size="20" weight="bold" transform="uppercase">
          Account Info
        </Text>
      </TextDoubleHeader>
      <AccountView
        user={props.usersFields}
        creditBalance={props.creditBalance}
      />
    </AccountInfoWrapper>
  );
};

export { AccountInfo };
